import * as t from './types';


export const changeFilter = (data) => ({ type: t.CHANGE_FILTERS_SUCCESS, payload: data });
export const resetFilter = (data) => ({ type: t.RESET_FILTERS_SUCCESS});

